<template>
  <modal
    width="380px"
    speed="fast"
    noOutClose
    maskNoClick
    :show="show"
    enter-active-class="fadeIn"
    leave-active-class="fadeOut"
    @update:show="handleShowUpdate"
    class="detect-tip-modal"
  >
    <p slot="header">提示</p>
    <p slot="content" class="text">
      您尚未通过{{detetcName}}，若因{{detetcName}}未通过而影响正常考试，由考生自行承担后果，是否继续进入考试？
    </p>
    <div slot="footer">
      <button class="white-btn" @click="goTest">进入考试</button>
      <button
        :style="
          'box-shadow: ' +
          $store.state.theme.buttonShadow +
          'background: ' +
          $store.state.theme.buttonBackground
        "
        class="blue-btn"
        @click="goDetect"
      >
        {{detetcName}}
      </button>
    </div>
  </modal>
</template>

<script>
import Modal from '@/components/Modal'
import { getExamId } from '@/utils';
export default {
  components: {
    Modal
  },
  data() {
    return {
      show: false,
      examId: undefined,
      isDoubleCamera: false
    }
  },
  methods: {
    goDetect() {
      this.$router.push({
        name: 'detect',
        query: {
          examId: this.$route.query.examId || this.examId || getExamId()
        }
      })
      this.close()
    },
    goTest() {
      this.$emit('goTest')
      this.close()
    },

    handleShowUpdate(val) {
      if (!val) {
        setTimeout(() => {
          this.examId = undefined
          this.isDoubleCamera = false
        }, 500)
        this.close()
      }
    },
    close() {
      this.show = false
      this.$emit('close')
    },
    open(examId, isDoubleCamera) {
      this.show = true
      this.examId = examId
      this.isDoubleCamera = isDoubleCamera
    }
  },
  watch: {
    show(val) {
      if (!val) {
        setTimeout(() => {
          this.examId = undefined
          this.isDoubleCamera = false
        }, 500)
      }
    }
  },
  computed: {
    detetcName() {
      return this.isDoubleCamera ? '双机位环境检测' : '设备检测'
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .modal-head {
  padding: 16px 20px;
  border-bottom: 1px solid #f1f1f1;
}
.white-btn {
  @include cancel-btn(96px, 36px, 14px, 4px);
  margin-right: 20px;
  margin-bottom: 10px;
}
.blue-btn {
  @include theme-fill-btn(96px, 36px, 14px, 4px);
  min-width: 96px;
  width: fit-content;
}
.text {
  font-size: 16px;
  margin: 10px 0;
}
</style>
